export enum ArtifactType {
  STEP_BY_STEP_TRAINING = 'STEP_BY_STEP_TRAINING',
  TEXT = 'TEXT',
  QUESTIONNAIRE_TRAINING = 'QUESTIONNAIRE_TRAINING',
}
